import { render, staticRenderFns } from "./MyProgramMetrics.vue?vue&type=template&id=00dc173b&scoped=true"
import script from "./MyProgramMetrics.vue?vue&type=script&lang=ts"
export * from "./MyProgramMetrics.vue?vue&type=script&lang=ts"
import style0 from "./MyProgramMetrics.vue?vue&type=style&index=0&id=00dc173b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dc173b",
  null
  
)

export default component.exports